export const FREE_SHIPPING_THRESHOLD = 500;
export const STANDARD_SHIPPING_RATE = 60;

export function calculateShipping(subtotal = 0) {
  const amount = Number(subtotal) || 0;
  return amount >= FREE_SHIPPING_THRESHOLD ? 0 : STANDARD_SHIPPING_RATE;
}

export function getFreeShippingRemaining(subtotal = 0) {
  const amount = Number(subtotal) || 0;
  return Math.max(0, FREE_SHIPPING_THRESHOLD - amount);
}
